module.exports = __webpack_public_path__ + "img/default.e20afba1.svg";